'use strict';

window.jQuery = require('jquery');
window.$ = require('jquery');
window.emailScramble = require('email-scramble');

export default '';
//module.exports = app;
